import React, { Component } from "react";
import Header from "./common/header/header.js";
import SideMenu from "./common/sideMenu/sideMenu.js";
import CreditLines from "./screens/creditLines/components/CreditLines.js";
import CustomerCreditDetails from "./screens/customerCreditDetails/components/CreditLines.js";
import CreditTransactions from "./screens/creditTransactions/components/creditTransactions.js";
import Login from "./screens/login/components/Login.js";
import "./assests/styles/app.css";
import CreateCreditLine from "./screens/instantCredit/components/createCreditLine.js";
import CreditAnchor from './screens/CreditAnchor/CreditAnchor'
var ReactRouter = require("react-router-dom");
var Router = ReactRouter.BrowserRouter;
var Route = ReactRouter.Route;

var user = localStorage.getItem("user");

class App extends Component {
	render() {
		return (
			<Router>
				<div>
					{!user ? (
						<div className="row">
							<div className="col-md-4" />
							<div className="col-md-4 log-in-box">
								<Login />
							</div>
							<div className="col-md-4" />
						</div>
					) : (
						<div>
							<div className="Header" id="header">
								<Header />
							</div>
							<div className="row" style={{ margin: "0px" }}>
								<div className="col-md-2 sideMenu" style={{ padding: "0px" }}>
									<SideMenu />
								</div>
								<div className="col-md-10" style={{ padding: "0px" }}>
									<Route exact path="/" component={CreditLines} />
									<Route exact path="/CreditLines" component={CreditLines} />
									<Route exact path="/customerCreditDetails" component={CustomerCreditDetails} />
									<Route exact path="/CreditTransactions" component={CreditTransactions} />
									<Route exact path="/CreditAnchor" component={CreditAnchor} />
									<Route exact path="/createCreditLine" component={CreateCreditLine} />
								</div>
							</div>
						</div>
					)}
				</div>
			</Router>
		);
	}
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js